module.exports = __webpack_public_path__ + "static/media/Semana de salud.ce684c5c.jpg";